<template>
    <div class="fixed inset-0 flex items-end justify-end px-4 py-6 pointer-events-none sm:p-7 sm:items-end sm:justify-end">
        <transition
            enter-active-class="transform ease-out duration-300 transition"
            enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition ease-in duration-100"
            leave-class="opacity-100"
            leave-to-class="opacity-0">
            <div v-if="show" :class="classes"
                 class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div class="p-4">
                    <div class="flex items-start">
                        <div class="self-center flex-shrink-0">
                            <!-- Heroicon name: outline/check-circle -->
                            <svg aria-hidden="true" class="h-9 w-9 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </svg>
                        </div>
                        <div class="ml-3 w-0 flex-1 pt-0.5">
                            <p class="text-lg text-green-600 font-bold">
                                {{ alert.message }}
                            </p>
                            <p v-if="alert.subMessage" class="mt-1 text-sm text-green-500 font-bold">
                                {{ alert.subMessage }}
                            </p>
                        </div>
                        <div class="ml-4 flex-shrink-0 flex">
                            <button
                                class="rounded-md inline-flex text-gray-400 hover:text-gray-800 transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                @click="onClose">
                                <span class="sr-only">Close</span>
                                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"
                                          stroke-width="2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>

</template>

<script>

export default {

    name: 'SimpleAlert',

    props: {
        alert: {
            default: null,
            type: Object
        }
    },

    computed: {
        classes() {

        }
    },

    watch: {},

    data() {
        return {
            show: !!this.alert
        };
    },

    methods: {
        onClose() {
            this.show = false;
        }
    }

};

</script>
